export const colors = {
    black: '#000000',
    blueDark: '#2A4365',
    grey: '#E0DFDF',
    greyBorder: '#D7D9DD',
    greyInputBorder: '#a7acb1',
    greyLight: '#EBEBEB',
    greyMedium: '#AEACAC',
    greyDark: '#6E757D',
    greyHighlight: '#F5F6F7',
    green: '#009878',
    infoAlert: '#EBF8FF',
    offBlack: '#2B2E31',
    orange: '#D14714',
    orangeHover: '#C13F02',
    success: '#4CAF50',
    white: '#FFFFFF',
    open: '#6CB946',
    closed: '#E40000',
};
